import React from 'react'

import { DeliveryInfoItem, DeliveryInfoItemProps } from '../DeliveryInfoItem/DeliveryInfoItem'

import cl from './DeliveryInfoList.module.scss'

export type DeliveryInfoListProps = {
	items: DeliveryInfoItemProps[]
	column?: boolean
	isModal?: boolean
}

export const DeliveryInfoList = ({ items, isModal }: DeliveryInfoListProps): JSX.Element => (
	<div className={cl.deliveryInfoList}>
		{items?.map(item => (
			<DeliveryInfoItem key={item.title} {...item} column={isModal} />
		))}
	</div>
)
